import { Flex, Text } from "@radix-ui/themes";
import { EvaluationTabItem } from "./EvaluationTabs";
import { AvgQaScoreFormatter } from "@/v2/components/formatters/AvgQaScoreFormatter";

export function EvaluationTabHeader({
  title,
  publicCommentsCount,
  totalAdjusted = 0,
  avgQaScore,
}: EvaluationTabItem) {
  return (
    <Flex justify={"between"}>
      <Flex direction={"column"}>
        <Text size={"4"} color={"gray"} weight={"medium"} highContrast>
          {title}
        </Text>

        {publicCommentsCount != null && (
          <Text size={"2"} color={"gray"}>
            {`${publicCommentsCount} Public Messages`}
          </Text>
        )}
      </Flex>

      <Flex gap={"2"} align={"center"}>
        {totalAdjusted > 0 && (
          <Text size={"2"} color={"gray"}>
            {`${totalAdjusted} ${
              totalAdjusted > 1 ? "adjustments" : "adjustment"
            }`}
          </Text>
        )}

        {avgQaScore != null && (
          <Text size={"2"} color={"gray"} highContrast>
            <AvgQaScoreFormatter value={avgQaScore} />
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
